import React, { useState, useEffect } from "react";
import {
  Container,
  Navbar,
  Table,
  Nav,
  Row,
  Col,
  Button,
  NavbarText,
  Card,
  Badge,
  Tooltip,
  NavbarToggler,
  NavbarBrand,
} from "reactstrap";
import MonthVsPayments from "./MonthVsPayments";
import { AGENCY_DASHBOARD, AGENCY_REPORT } from "../../../constants/ApiPaths";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import moment from "moment";
import Swal from "sweetalert2";
import { logout } from "../../../functions/CoreFunctions";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getAgencyId, getAgencyURL } from "../../common/CommonFunctions";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import defaultAvatar from "../../../constants/Images/defaultAvatar-1.png";
import { Info } from "../../common/Info";
import logo from "../../../images/logo.png";
function AgencyDashBoard() {
  const [list, setList] = useState({});
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [activeMenu, setActiveItem] = useState("");
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const callAPIReport = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: AGENCY_REPORT,
      headers: authHeader(),
      params: {
        agencyId: getAgencyId(),
      },
    };
    try {
      const response = await API(config);
      const { status, monthwisePaymentReport } = response.data;
      if (status === "Success") {
        const payment = monthwisePaymentReport.map((data) => ({
          name: data.report,
          amount: parseFloat(data.amount).toFixed(2),
          sign: "$",
        }));
        setDatas(payment);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };

  const callAPIData = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: AGENCY_DASHBOARD,
      headers: authHeader(),
      params: { agencyId: getAgencyId() },
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        setList(response.data);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };

  let history = useNavigate();
  let Logout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to sign out",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sign Out",
    }).then((result) => {
      if (result.isConfirmed) {
        logout(history);
      }
    });
  };

  useEffect(() => {
    callAPIReport();
    callAPIData();
  }, []);

  const {
    totalPayment = [],
    userCount = [],
    totalLicense = [],
    totalAgencyUser = [],
    recentLicenseRequest = [],
    recentTransaction = [],
  } = list;

  //get Template Status
  const getTemplateStatus = {
    Approved: (
      <Badge color="success" className="mr-3 badge-success-soft">
        Approved
      </Badge>
    ),
    Pending: (
      <Badge color="warning" className="mr-3 badge-warning-soft">
        Pending
      </Badge>
    ),
    New: (
      <Badge color="info" className="mr-3 badge-info-soft">
        New
      </Badge>
    ),
    Rejected: (
      <Badge color="danger" className="mr-3 badge-danger-soft">
        Rejected
      </Badge>
    ),
     "Payment Completed": (
     <Badge color="info" className="mr-3 badge-primary-soft">
      Payment Completed
    </Badge>
    ),
  };

  const [firstName, setFirstName] = useState();
  const [lastName, setlastName] = useState();
  const [profileimage, setProfile] = useState();
  const reduxState = useSelector((state) => state.AuthUserDetailsReducer);

  useEffect(() => {
    const { firstName, lastName, profileImage = "" } = reduxState;

    if (profileImage) {
      setProfile(profileImage);
    } else {
      setProfile(defaultAvatar);
    }

    setFirstName(firstName);
    setlastName(lastName);
  }, [reduxState]);

  // AgencyUrl Customer Portal
  useEffect(() => {
    let currentActive = window.location.href.split("/") || "/";
    let urlElement = `${currentActive[0]}//${currentActive[2]}`;
    setActiveItem(urlElement);
  }, []);

  return (
    <div>
      {loading && <CustomPageLoading />}

      <div>
        <Navbar
          className="agency-navbar"
          fixed={"top"}
          color="light"
          light
          expand="lg"
        >
          <NavbarBrand href="/">
            {" "}
            <img className="logo" src={logo} alt="" />
          </NavbarBrand>
          <NavbarToggler />
        </Navbar>
      </div>

      <div className="agency-wrapper">
        <Container fluid>
          <div className="page-title mb-4">
            <Navbar light expand="md" className="agency-dashboard">
              <Nav className="mr-auto" navbar>
                <h4 className="homeName">
                  {firstName} {lastName} {"    "}
                  <a
                    href={`${activeMenu}/agencyplan/${getAgencyURL()}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="ageny-header-profile">|</span>
                    {`/agencyplan/${getAgencyURL()}`}
                  </a>
                  <a
                    href={`${activeMenu}/customer/${getAgencyURL()}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="ageny-header-profile">|</span>
                    {`/customer/${getAgencyURL()}`}
                  </a>
                </h4>
              </Nav>

              <NavbarText
                className="d-none"
                style={{ cursor: "pointer" }}
                onClick={() => Logout()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                >
                  <g id="logout" transform="translate(-1410 -12)">
                    <rect
                      id="Rectangle_1123"
                      data-name="Rectangle 1123"
                      width="35"
                      height="35"
                      rx="5"
                      transform="translate(1410 12)"
                      fill="#e4efff"
                    />
                    <path
                      id="exit"
                      d="M11.852,12.327v1.258A2.518,2.518,0,0,1,9.336,16.1H3.016A2.518,2.518,0,0,1,.5,13.584V2.516A2.518,2.518,0,0,1,3.016,0H9.336a2.518,2.518,0,0,1,2.516,2.516V3.773a.629.629,0,0,1-1.258,0V2.516A1.259,1.259,0,0,0,9.336,1.258H3.016A1.259,1.259,0,0,0,1.758,2.516V13.584a1.259,1.259,0,0,0,1.258,1.258H9.336a1.259,1.259,0,0,0,1.258-1.258V12.327a.629.629,0,0,1,1.258,0ZM16.14,6.97,14.731,5.561a.629.629,0,1,0-.889.889l1,1H7.292a.629.629,0,1,0,0,1.258h7.551l-1,1a.629.629,0,1,0,.889.889L16.14,9.193a1.574,1.574,0,0,0,0-2.224Zm0,0"
                      transform="translate(1418.5 21)"
                      fill="#1b3e6f"
                    />
                  </g>
                </svg>
              </NavbarText>
            </Navbar>
          </div>

          <Row>
            <Col md="12" lg="7" className="agencychart-order">
              <MonthVsPayments data={datas} loading={loading} />
            </Col>
            <Col md="12" lg="5">
              <Card body>
                <div className="agency-dash-details">
                  <img className="profile" src={profileimage} alt="" />

                  <h6>
                    {firstName} {lastName}
                  </h6>
                  <Link
                    to={{
                      pathname: "/agency/settings",
                    }}
                  >
                    <Button color="primary">View Profile</Button>
                  </Link>

                  <Row>
                    <Col sm="6" md="6" lg="12" xl="6">
                      <div className="box">
                        <div className="icon">
                          <svg
                            id="Icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="38"
                            height="38"
                            viewBox="0 0 38 38"
                          >
                            <g
                              id="Icon.BG"
                              fill="none"
                              stroke="#1b3e6f"
                              strokeWidth="1"
                            >
                              <circle cx="19" cy="19" r="19" stroke="none" />
                              <circle cx="19" cy="19" r="18.5" fill="none" />
                            </g>
                            <text
                              id="_"
                              dataname="$"
                              transform="translate(13 26)"
                              fill="#1b3e6f"
                              fontSize="20"
                              fontFamily="Rubik-Regular, Rubik"
                            >
                              <tspan x="0" y="0">
                                $
                              </tspan>
                            </text>
                          </svg>
                        </div>
                        <div className="count">
                          <h5>
                            {totalPayment.map((data) => {
                              const { totalPayment } = data;
                              return parseFloat(totalPayment).toFixed(2);
                            })}
                          </h5>
                          <span>Revenue</span>
                        </div>
                      </div>
                    </Col>
                    <Col sm="6" md="6" lg="12" xl="6">
                      <div className="box">
                        <div className="icon">
                          <svg
                            id="Icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="38"
                            height="38"
                            viewBox="0 0 38 38"
                          >
                            <g
                              id="Icon.BG"
                              fill="none"
                              stroke="#1b3e6f"
                              strokeWidth="1"
                            >
                              <circle cx="19" cy="19" r="19" stroke="none" />
                              <circle cx="19" cy="19" r="18.5" fill="none" />
                            </g>
                            <path
                              id="Icon_awesome-users"
                              data-name="Icon awesome-users"
                              d="M3.345,8.94a2.23,2.23,0,1,0-2.23-2.23A2.232,2.232,0,0,0,3.345,8.94Zm15.609,0a2.23,2.23,0,1,0-2.23-2.23A2.232,2.232,0,0,0,18.954,8.94Zm1.115,1.115h-2.23a2.223,2.223,0,0,0-1.571.648,5.1,5.1,0,0,1,2.617,3.812h2.3A1.114,1.114,0,0,0,22.3,13.4V12.284A2.232,2.232,0,0,0,20.069,10.054Zm-8.919,0a3.9,3.9,0,1,0-3.9-3.9A3.9,3.9,0,0,0,11.149,10.054Zm2.676,1.115h-.289a5.388,5.388,0,0,1-4.773,0H8.473A4.015,4.015,0,0,0,4.46,15.183v1a1.673,1.673,0,0,0,1.672,1.672H16.166a1.673,1.673,0,0,0,1.672-1.672v-1A4.015,4.015,0,0,0,13.825,11.169ZM6.031,10.7a2.223,2.223,0,0,0-1.571-.648H2.23A2.232,2.232,0,0,0,0,12.284V13.4a1.114,1.114,0,0,0,1.115,1.115h2.3A5.109,5.109,0,0,1,6.031,10.7Z"
                              transform="translate(8 8.75)"
                              fill="#1b3e6f"
                            />
                          </svg>
                        </div>
                        <div className="count">
                          <h5>
                            {userCount.map((data) => {
                              const { userCount } = data;
                              return userCount;
                            })}
                          </h5>
                          <span>Customers</span>
                        </div>
                      </div>
                    </Col>
                    <Col sm="6" md="6" lg="12" xl="6">
                      <div className="box">
                        <div className="icon">
                          <svg
                            id="Icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="38"
                            height="38"
                            viewBox="0 0 38 38"
                          >
                            <g
                              id="Icon.BG"
                              fill="none"
                              stroke="#1b3e6f"
                              strokeWidth="1"
                            >
                              <circle cx="19" cy="19" r="19" stroke="none" />
                              <circle cx="19" cy="19" r="18.5" fill="none" />
                            </g>
                            <path
                              id="Icon_awesome-dog"
                              data-name="Icon awesome-dog"
                              d="M17.858,4.554h-2.3L15.3,4.039a1.152,1.152,0,0,0-1.03-.637H12.335l-.982-.982a.576.576,0,0,0-.984.407V8.222l4.609,1.646V8.587H16.13a2.3,2.3,0,0,0,2.3-2.3V5.13A.576.576,0,0,0,17.858,4.554ZM13.826,6.283a.576.576,0,1,1,.576-.576A.576.576,0,0,1,13.826,6.283ZM3.456,9.163A1.154,1.154,0,0,1,2.3,8.011a1.152,1.152,0,1,0-2.3,0,3.45,3.45,0,0,0,2.3,3.244v7.7a.576.576,0,0,0,.576.576h2.3a.576.576,0,0,0,.576-.576V14.923h5.761v4.032a.576.576,0,0,0,.576.576h2.3a.576.576,0,0,0,.576-.576V11.091l-5.4-1.928Z"
                              transform="translate(10 7.75)"
                              fill="#1b3e6f"
                            />
                          </svg>
                        </div>
                        <div className="count">
                          <h5>
                            {totalLicense.map((data) => {
                              const { licenseCount } = data;
                              return licenseCount;
                            })}
                          </h5>
                          <span>Issued Licenses</span>
                        </div>
                      </div>
                    </Col>
                    <Col sm="6" md="6" lg="12" xl="6">
                      <div className="box">
                        <div className="icon">
                          <svg
                            id="Icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="38"
                            height="38"
                            viewBox="0 0 38 38"
                          >
                            <g
                              id="Icon.BG"
                              fill="none"
                              stroke="#1b3e6f"
                              strokeWidth="1"
                            >
                              <circle cx="19" cy="19" r="19" stroke="none" />
                              <circle cx="19" cy="19" r="18.5" fill="none" />
                            </g>
                            <path
                              id="Icon_metro-suitcase"
                              data-name="Icon metro-suitcase"
                              d="M19.881,21.166H5.729A1.231,1.231,0,0,1,4.5,19.936V12.552a31.331,31.331,0,0,0,6.153,2.328v.748a.615.615,0,0,0,.615.615h3.076a.615.615,0,0,0,.615-.615V14.88a31.349,31.349,0,0,0,6.153-2.328v7.383A1.231,1.231,0,0,1,19.881,21.166Zm-6.153-7.383a.615.615,0,0,1,.615.615v.615a.615.615,0,0,1-.615.615H11.882a.615.615,0,0,1-.615-.615V14.4a.615.615,0,0,1,.615-.615Zm1.231,0a.615.615,0,0,0-.615-.615H11.267a.615.615,0,0,0-.615.615v.551a30.82,30.82,0,0,1-6.153-2.4V9.476A1.231,1.231,0,0,1,5.729,8.245H9.421V7.015a1.231,1.231,0,0,1,1.231-1.231h4.307a1.231,1.231,0,0,1,1.231,1.231V8.245h3.692a1.231,1.231,0,0,1,1.231,1.231v2.461a30.838,30.838,0,0,1-6.153,2.4v-.551Zm0-6.153a.615.615,0,0,0-.615-.615H11.267a.615.615,0,0,0-.615.615v.615h4.307Z"
                              transform="translate(6.501 5.216)"
                              fill="#1b3e6f"
                            />
                          </svg>
                        </div>
                        <div className="count">
                          <h5>
                            {totalAgencyUser.map((data) => {
                              const { roleBasedCount, count } = data;
                              if (roleBasedCount === "Agency Employee") {
                                return count;
                              } else {
                                return null;
                              }
                            })}
                          </h5>
                          <span>Employees</span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col lg="6">
              <div className="page-title">
                <h4>
                  Recent License Request
                  <Tooltip
                    isOpen={id === "licenserequesst" && tooltipOpen}
                    target={"licenserequesst"}
                    toggle={() => tooltiptoggle("licenserequesst")}
                  >
                    Recent License Request
                  </Tooltip>
                  <span id={"licenserequesst"}>
                    <Info />
                  </span>
                </h4>

                <div className="top-btn">
                  <Link
                    to={`/agency/license?dashboard=Pending`}
                    // to={{
                    //   pathname: `/agency/license?dashboard=Pending`,
                    //   state: { dashboard: "Pending" },
                    // }}
                  >
                    <Button size="sm" color="primary">
                      View all
                    </Button>
                  </Link>
                </div>
              </div>

              {/* table */}

              <Card body className="mt-4">
                <Table hover responsive>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      ""
                    ) : recentLicenseRequest.length === 0 ? (
                      <tr>
                        <td colSpan={4}>
                          <center>No Records Found</center>
                        </td>
                      </tr>
                    ) : (
                      recentLicenseRequest.map((data) => {
                        const {
                          templateId,
                          typeofLicense,
                          createdDate,
                          licenseStatus,
                        } = data;
                        return (
                          <tr key={templateId}>
                            <td>{typeofLicense}</td>
                            <td>{moment(createdDate).format("MM/DD/YYYY")}</td>
                            <td>{getTemplateStatus[licenseStatus]}</td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </Card>
            </Col>
            <Col lg="6">
              <div className="page-title">
                <h4>
                  Recent Transactions
                  <Tooltip
                    isOpen={id === "recent" && tooltipOpen}
                    target={"recent"}
                    toggle={() => tooltiptoggle("recent")}
                  >
                    Recent Transactions
                  </Tooltip>
                  <span id={"recent"}>
                    <Info />
                  </span>
                </h4>

                <div className="top-btn">
                  <Link
                    to={{
                      pathname: "/agency/customerpaymentreport",
                    }}
                  >
                    <Button size="sm" color="primary">
                      View all
                    </Button>
                  </Link>
                </div>
              </div>

              {/* table */}

              <Card body className="mt-4">
                <Table hover responsive>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Date</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      ""
                    ) : recentTransaction.length === 0 ? (
                      <tr>
                        <td colSpan={3}>
                          <center>No Records Found</center>
                        </td>
                      </tr>
                    ) : (
                      recentTransaction.map((data) => {
                        const { createdDate, name, amount, paymentDetailId } =
                          data;
                        return (
                          <tr key={paymentDetailId}>
                            <td>{name}</td>
                            <td>{moment(createdDate).format("MM/DD/YYYY")}</td>
                            <td>${parseFloat(amount).toFixed(2)}</td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default AgencyDashBoard;
